var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('div',{staticClass:"text-question"},[_c('div',{staticClass:"question-title",class:item.colorClass},[_c('span',[_vm._v(_vm._s(item.title))])]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.isTypeFile ? _vm.linkify(item.text) : item.text)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }